import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'
import Select from 'react-select'

import { AiOutlineDown } from 'react-icons/ai'

import EditReportTemplate from '../../../components/drawers/editReportTemplate'
import NewReportTemplate from '../../../components/drawers/newReportTemplate'
import Receive from '../../../components/reusable/receive'

import { normalizeCase, stringifyDate, useListData, usePet, useToggle } from '../../../modules'

import { departments } from "../../../data"

const Reports = () => {
    const [selected, setSelected] = useState()
    const [department, setDepartment] = useState()
    const [string, setString] = useState('')

    const [newTemplateModal, toggleNewTemplateModal] = useToggle()
    const [templateModal, toggleTemplateModal] = useToggle()

    const select = usr => {
        setSelected(usr)
        toggleNewTemplateModal()
    }
    
    const [
        { loading, error, fetch }, 
        { list: templates }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('reportTemplates', { string, department: department?.value }, { notify: true, manual: false }, 'templates')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const changeDepartment = dept => {
        setDepartment(dept)
        refresh()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Template has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        refresh()
    }

    const [, execute] = usePet('toggleActive', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = usr => {
        setSelected(usr)
        execute()        
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newTemplateModal &&
                <NewReportTemplate
                    onPerform={ fetch }
                    departments={ departments }
                    visible={ newTemplateModal }
                    toggle={ toggleNewTemplateModal } />
            }            
            {
                templateModal &&
                <EditReportTemplate
                    onPerform={ fetch }
                    template={ selected }
                    toggle={ toggleTemplateModal }
                    visible={ templateModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewTemplateModal } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">New Template</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 flex justify-between items-center border-b border-gray-100">
                    <h2 className="font-semibold text-gray-800">Report Templates</h2>
                    <Select
                        isClearable
                        value={ department }
                        onChange={ changeDepartment }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={departments?.map(dept => ({ label: normalizeCase(dept?.replace('-', ' ')), value: dept }))}
                        placeholder="Select Department" />
                </header>
                <div className="p-3 overflow-x-auto">
                    <Receive
                        error={error}
                        loading={loading}
                        progress>
                        {
                            templates.length > 0 ?
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm text-left">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Name</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Department</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Status</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Created By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Date</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {/* Row */}
                                        {
                                            templates.map((template, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div>{((page - 1) * limit) + key + 1}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{ template.name }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div>{ normalizeCase(template?.department?.replace('-', ' ')) }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className={ template.active ? 'text-green-500' : 'text-gray-700' }>{ template.active ? 'Active' : 'Inactive' }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div>{ template?.createdBy?.name }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div>{ stringifyDate(template.date) }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Menu.Item onClick={ () => select(template) }>View</Menu.Item>
                                                                    <Menu.Item onClick={ () => toggleActive(template) }>{ template.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">Please click above to add a new template</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </div>
    )
}

export default Reports